var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestChatArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24.6,
    height: 24.6,
    viewBox: "0 0 24.6 24.6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18 11.7002C21.4794 11.7002 24.2998 14.5206 24.2998 18C24.2998 21.4794 21.4794 24.2998 18 24.2998C14.5206 24.2998 11.7002 21.4794 11.7002 18C11.7002 14.5206 14.5206 11.7002 18 11.7002ZM12 0.299805C18.4617 0.299805 23.7002 5.53827 23.7002 12C23.7002 12.0806 23.696 12.161 23.6943 12.2412C23.4104 11.9604 23.106 11.7005 22.7832 11.4639C22.5036 5.74823 17.7848 1.2002 12 1.2002C6.03533 1.2002 1.2002 6.03533 1.2002 12C1.2002 13.9669 1.7258 15.81 2.64355 17.3975C2.70426 17.5027 2.71967 17.6282 2.68652 17.7451L1.41699 22.2109L1.26953 22.7285L1.78711 22.5811L6.25195 21.3115C6.36898 21.2784 6.4943 21.2946 6.59961 21.3555C8.04286 22.1904 9.69775 22.699 11.4648 22.7852C11.7011 23.1073 11.9609 23.4109 12.2412 23.6943C12.161 23.696 12.0806 23.7002 12 23.7002C9.98147 23.7002 8.08101 23.1888 6.42285 22.2881L6.31543 22.2295L6.19824 22.2627L1.25684 23.668C0.691676 23.8287 0.169361 23.3064 0.330078 22.7412L1.73535 17.7988L1.76855 17.6816L1.71094 17.5742C0.81128 15.9168 0.299805 14.0173 0.299805 12C0.299805 5.53827 5.53827 0.299805 12 0.299805ZM21.5996 14.7002C21.1029 14.7004 20.7004 15.1029 20.7002 15.5996C20.7002 16.7594 19.7594 17.7002 18.5996 17.7002H15.9727L16.2363 17.4365C16.5877 17.0851 16.5876 16.5156 16.2363 16.1641C15.8849 15.8126 15.3153 15.8126 14.9639 16.1641L13.1641 17.9639C12.8126 18.3153 12.8126 18.8849 13.1641 19.2363L14.9639 21.0361C15.3153 21.3876 15.8849 21.3876 16.2363 21.0361C16.5877 20.6847 16.5878 20.1151 16.2363 19.7637L15.9727 19.5H18.5996C20.7535 19.5 22.5 17.7535 22.5 15.5996C22.4998 15.1027 22.0965 14.7002 21.5996 14.7002Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestChatArrow);
export default __webpack_public_path__ + "static/media/request-chat-arrow.e2d378d2bb27e88af0509b6bfd0e0688.svg";
export { ForwardRef as ReactComponent };